import { put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "../../../common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  onlineAssetsPrice: "onlineAssetsPrice [Action]",
  onlineAssetsPriceLoading: "onlineAssetsPriceLoading [Action]",
  onlineAssetsPriceAsync: "onlineAssetsPriceAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const online_assets_priceReducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.onlineAssetsPrice:
      return {
        ...state,
        data: payload,
        total: payload?.total,
      };
    case actionTypes.onlineAssetsPriceLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.onlineAssetsPriceLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "gold",
    method_type: "online_assets_price",
    data: payload?.data ? payload.data : {},
  };

  try {
    let res = yield AxiosCustom(config, data);

    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }

    yield put({
      type: actionTypes.onlineAssetsPrice,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.onlineAssetsPriceLoading,
      payload: false,
    });
  }
}

export function* onlineAssetsPrice() {
  yield takeLatest(actionTypes.onlineAssetsPriceAsync, handleWorker);
}
